import { render } from "./InteractivePanel.vue?vue&type=template&id=3949dbb4&scoped=true"
import script from "./InteractivePanel.vue?vue&type=script&lang=js"
export * from "./InteractivePanel.vue?vue&type=script&lang=js"

import "./InteractivePanel.vue?vue&type=style&index=0&id=3949dbb4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3949dbb4"]])

export default __exports__